// i18n area 'storage' — locale fi-FI (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/storage.fi-FI.meta.json.
import type { enUS } from './storage'

export const fiFI: typeof enUS = {
  storage: {
    pools: {
      title: 'Storage',
      createTitle: 'Luo storage',
      path: 'Polku',
      pathHint: 'Absoluuttinen polku sallitun rootin alla (oletus /var/lib/tvirt/pools/)',
      shared: 'Jaettu storage',
      sharedChip: 'jaettu',
      sharedVerifiedChip: 'jaettu · todennettu',
      sharedVerifiedTooltip: 'Jako todennettu: ristikkäiset luotaimet vahvistavat, että jokainen jäsen näkee muiden kirjoittaman datan.',
      sharedDisputedChip: 'jaettu · EI todennettu',
      sharedDisputedTooltip: 'Jakoa EI ole todennettu',
      sharedDisputedPair: '{observer} ei näe dataa, jonka {writer} kirjoitti',
      sharedHint: 'Verkon share, mountattu paikallisesti samaan polkuun jokaisella jäsenellä — live migrationin edellytys (deklaratiivinen).',
      sharedDanger: 'VAARA — TVirt USKOO tätä flagia: kun kytket sen päälle, jokainen jäsen olettaa näkevänsä SAMAT tavut tässä polussa. Kansiolla, joka EI ole aidosti jaettu share (NFS/CIFS/klusteritiedostojärjestelmä), tuloksena on korruptio ja datan menetys ensimmäisen migroinnin tai toisella solmulla tapahtuvan ensimmäisen HA-uudelleenkäynnistyksen yhteydessä. Kytke se päälle vain, jos polku on share, joka on mountattu identtisesti jokaisella solmulla.',
      type: 'Tyyppi',
      capacity: 'Kapasiteetti',
      provisioned: 'Allokoitu',
      provisionedOvercommit: 'Potentiaalinen sitoumus yli kapasiteetin: thin-volyymit voivat kasvaa {n} GiB:iin asti.',
      phase: { ready: 'Valmis', degraded: 'Heikentynyt', error: 'Virhe' },
      tabConfig: 'Konfiguraatio',
      tabCapacity: 'Kapasiteetti ja tila',
      cardIdentity: 'Identiteetti',
      cardPlacement: 'Sijainti',
      cardConnection: 'Yhteys',
      usedReal: 'Todellinen käyttö',
      capacityUnknown: 'Solmu ei ole vielä raportoinut tämän poolin kapasiteettia — täällä ei keksitä lukuja',
      overcommitHint: 'Sitoumus yli kapasiteetin: legitiimiä thin-pooleilla, pidä silmällä todellista käyttöä',
      supportedContent: 'Tuetut sisällöt',
      content: {
        disks: 'Levyt',
        catalogFiles: 'Katalogitiedostot',
        backups: 'Varmuuskopiot',
        appVolumes: 'App-volyymit'
      },
      defaultDiskFormat: 'Levyn oletusformaatti',
      reserveGiB: 'Varattu vapaa tila (GiB)',
      available: 'Käytettävissä',
      diskCount: 'Levyt',
      filesystem: 'Tiedostojärjestelmä',
      observedAt: 'Havaittu',
      lostAtRow: 'Julistettu menetetyksi',
      sharedProbeRow: 'Jaon todennus',
      sharedProbeNodes: 'Luodatut solmut',
      reachableFrom: 'Ilmoitettu tavoitettavuus',
      reachableFromHint: 'Solmut, joilta tämän storagen on oltava tavoitettavissa. VM, jolla on levyjä, ISOja tai metadataa täällä, ei käynnisty eikä migroidu solmulle tämän listan ulkopuolella. Kaikki jäsenet on esivalittu: rajaa miten haluat. Solmu, joka liittyy klusteriin myöhemmin, jää ulkopuolelle, kunnes lisäät sen tänne.',
      reachableFromNone: 'ei ilmoitettu',
      reachableFromTags: 'Saavutettavuus tagin mukaan',
      reachableFromTagsHint: 'Valitsin tag=arvo (pilkuin erotellut merkinnät, AND): jokainen näitä tageja kantava jäsen julistetaan saavutettavaksi — dynaamisesti: solmun tagaaminen tuo sen mukaan.',
      reachableFromTagsInvalid: 'Virheellinen muoto — käytä tag=arvo, pilkuin eroteltuna',
      reachableResolved: 'Ratkaistut solmut: {nodes}',
      reachableDeclaredNotSeen: 'ilmoitettu, mutta jakoluotain ei nähnyt sitä solmuilla: {nodes}',
      reachableSeenNotDeclared: 'nähty, mutta ei ilmoitettu (perimetrin ulkopuolella) solmuilla: {nodes}',
      cephCluster: 'Hallittu Ceph-klusteri',
      appGuardTitle: 'Storage Appien käytössä',
      appEphemeralGuard: 'tämä storage on Appien klusteritason efemeraalinen pool — vaihda se ensin App-sivulta ja poista se vasta sitten.',
      appInUseGuard: 'täällä elävät appien rootit/volyymit: {apps} — siirrä tai poista ne ensin.',
      releaseRequiredTitle: "Poistetaanko '{name}' ja vapautetaanko sen imaget?",
      releaseRequiredBatchTitle: 'Poistetaanko valitut storaget ja vapautetaanko niiden imaget?',
      releaseRequiredBody: 'Imagejen vapauttaminen ei poista YHTÄÄN tavua: rekisteröinnin purku jättää namespacen levylle, imaget eivät vain enää ole materialisoituja ja jokainen scopejen viittaus säilyy claimina — rekisteröi pool uudelleen, niin ne adoptoidaan takaisin.',
      releaseConfirm: 'Poista ja vapauta imaget'
    },
    lost: {
      chip: 'Menetetty',
      action: 'Julista menetetyksi',
      confirmTitle: 'Julista storage menetetyksi',
      confirmBody: 'Operaattorin attestointi omalla ilmoitetulla riskillä: jokainen jonossa tai käynnissä oleva task tällä storagella tai sen objekteilla EPÄONNISTUU, poistot muuttuvat pelkiksi rekisterikirjauksiksi (ei työtä tiedostojärjestelmässä) ja uusi fyysinen työ hylätään. Tavuihin ei koskaan kosketa — jos volyymi herää henkiin, rekisteröi se uudelleen ja aja skannaus adoptoidaksesi kaiken takaisin.',
      confirmSubmit: 'Julista menetetyksi',
      error: 'Attestointi hylättiin'
    },
    findings: {
      action: 'Löydetyt objektit',
      title: 'Löydetyt objektit',
      empty: 'Ei löydettyjä objekteja storagen namespacessa',
      loadError: 'Löydettyjä objekteja ei voitu ladata',
      actionError: 'Päätös hylättiin',
      colKind: 'Tyyppi',
      colObject: 'Objekti',
      colConflict: 'Konflikti',
      namespaceNotice:
        'Tämä hakemisto oli jo alustettu toisen tallennustilan toimesta: identiteettisinetti on korvattu tämän tallennustilan sinetillä. Sisältöön EI ole koskettu — käy alla löytyneet objektit läpi, tuo tarvitsemasi ja hylkää sitten tämä ilmoitus.',
      kind: {
        disk: 'Levy',
        catalogFile: 'Katalogitiedosto',
        vmMetadata: 'VM-metadata',
        namespace: 'Namespace',
        foreign: 'Vieras',
        volumeGroup: 'Volume group'
      },
      vgAdopt: {
        action: 'Adoptoi volume group',
        title: 'Adoptoi volume group',
        intro:
          'Tällä laitteella on jo volume group, jolla on TVirtin nimi, mutta sen sinetti ei nimeä yhtään tänne rekisteröityä storagea. Se voi olla se, minkä TÄMÄN klusterin aiempi storage jätti LUNille — tai se, minkä TOINEN TVirt-klusteri jätti LUNille, joka on vaihtanut omistajaa: täältä katsottuna tapaukset ovat identtiset, ja siksi kukaan ei päätä puolestasi.',
        irreversible: 'Katso laite, sinetti ja nimi ennen jatkamista: adoptointia ei voi perua.',
        device: 'Laite',
        seal: 'Sinetti',
        sealNone: 'ei mitään (ei tvirt.storageId-tunnistetta)',
        renameTo: 'Uudelleennimetään muotoon',
        renameNone: 'Ei uudelleennimeämistä: nimi on jo se, jonka tämä storage johtaa',
        volumesNote:
          'Sisältyviä volumeja EI adoptoida tällä eleellä: seuraava skannaus tarjoaa ne yksitellen tavallisina löydettyinä objekteina.'
      },
      conflictChip: 'ID on jo olemassa',
      dismissedChip: 'Ohitettu',
      adopt: 'Adoptoi',
      adoptFileTitle: 'Tuo katalogiin',
      adoptFileHint: 'Tiedostot ovat olemassa vain katalogien sisällä: valitse löydetylle tiedostolle kohdekatalogi.',
      purge: 'Poista levyltä',
      dismiss: 'Ohita',
      purgeConfirmTitle: 'Poista levyltä',
      purgeConfirmBody: 'Kohteen {id} löydetyt tavut poistetaan storagelta. Operaatio ei ole peruttavissa.',
      taskStarted: 'Käynnistetty — jatkuu taskina taustalla',
      scan: 'Skannaa storage',
      scanStarted: 'Skannaus käynnistetty…',
      scanDone: 'Skannaus valmis — löydetyt objektit on päivitetty'
    },
    reinit: {
      action: 'Yritä alustusta uudelleen'
    },
    wizard: {
      addButton: 'Lisää',
      title: 'Lisää storage',
      back: 'Takaisin',
      continue: 'Jatka',
      selectHint: 'Valitse protokolla nähdäksesi, miten TVirt käyttää sitä.',
      roadmap: 'Roadmap',
      server: 'Palvelin',
      export: 'Export-polku',
      share: 'Share',
      username: 'Käyttäjänimi',
      password: 'Salasana',
      passwordHint: 'Vain kirjoitus: käytetään mounttaukseen, ei koskaan näytetä uudelleen.',
      credential: 'Tunnistetieto',
      credentialManual: 'Syötä käsin',
      credentialHint: 'Keystoren merkintä tyyppiä käyttäjänimi ja salasana — vaihtoehto niiden näppäilylle tässä.',
      credentialEmpty: 'Keystoressa ei ole käyttäjänimi ja salasana -tyypin tunnistetietoa — luo sellainen kohdassa Järjestelmä → Tunnistetiedot tai näppäile tili tähän alle.',
      options: 'Mount-valinnat',
      optionsHint: 'Pilkuin eroteltuina, välitetään mount -o:lle sellaisinaan.',
      portal: 'Portal',
      portalHint: 'host[:portti] — oletusportti on 3260.',
      target: 'Target IQN',
      targetHint: 'iSCSI-targetin nimi, alkaa etuliitteellä iqn.',
      lun: 'LUN',
      wholeLunRow: 'Levyillä: tämä tallennus nimeää vain kohteen',
      wholeLunHint: 'Tämä tallennus nimeää vain kohteen: sen LUNit muuttuvat levyiksi yksi kerrallaan (Luo levy → ota käyttöön koko LUN), kohteeseen ei kirjoiteta mitään.',
      lunHint: 'LUN-numero targetilla — jos epäröit, 0.',
      chapCredential: 'Tunnistetieto (CHAP)',
      chapCredentialHint: 'Keystoren CHAP (iSCSI) -tyypin merkintä, jota käytetään kirjautumiseen — salaisuus ei koskaan kulje storagen mukana.',
      chapNone: 'Ei todennusta',
      chapEmpty: 'Keystoressa ei ole CHAP (iSCSI) -tyypin tunnistetietoa — luo sellainen kohdassa Järjestelmä → Tunnistetiedot. Ilman sitä kirjautuminen jää todentamattomaksi.',
      address: 'Osoite',
      addressHint: 'NVMe/TCP-targetin host tai IP (traddr).',
      port: 'Portti',
      portHint: 'Targetin TCP-portti — 4420, jos jätetään tyhjäksi.',
      targetNqn: 'Target NQN',
      targetNqnHint: 'Subsystemin NQN targetilla, alkaa etuliitteellä nqn.',
      nsid: 'NSID',
      nsidHint: 'Namespace ID subsystemin sisällä — jos epäröit, 1.',
      dhchapCredential: 'Tunnistetieto (DH-HMAC-CHAP)',
      dhchapCredentialHint: 'Keystoren DH-HMAC-CHAP (NVMe) -tyypin merkintä, jota käytetään yhdistettäessä — salaisuus ei koskaan kulje storagen mukana.',
      dhchapNone: 'Ei todennusta',
      dhchapEmpty: 'Keystoressa ei ole DH-HMAC-CHAP (NVMe) -tyypin tunnistetietoa — luo sellainen kohdassa Järjestelmä → Tunnistetiedot. Ilman sitä yhteys jää todentamattomaksi.',
      monitors: 'Monitorit',
      monitorsHint: 'Ceph-monitorien endpointit, host[:portti], pilkuin tai rivinvaihdoin eroteltuina — oletusportti 6789.',
      pool: 'Pool',
      poolHint: 'Käytettävä RBD-pool — yksi RBD-levykuva levyä kohden.',
      fs: 'Tiedostojärjestelmä',
      fsHint: 'CephFS-tiedostojärjestelmän nimi (mds_namespace mountissa).',
      fsPath: 'Polku tiedostojärjestelmän sisällä',
      fsPathHint: 'Absoluuttinen polku sen tiedostojärjestelmän sisällä, jonka storage mounttaa — jos epäröit, /.',
      cephxCredential: 'Tunnistetieto (cephx)',
      cephxCredentialHint: 'Keystoren cephx-tyypin merkintä: username = clientin nimi (client.…), secret = base64-avain. Pakollinen.',
      cephxNone: 'Keystoressa ei ole cephx-tunnistetietoa — luo sellainen (tyyppi: cephx) kohdassa Järjestelmä → Tunnistetiedot, tai anna hallitun Ceph-klusterin luoda se toiminnolla "Ehdota storageksi".',
      sharedByNature: 'Verkkostoraget ovat luonnostaan jaettuja: jokainen jäsen mounttaa ne samaan TVirtin hallitsemaan polkuun.',
      error: 'Storage hylättiin',
      category: {
        nas: 'NAS',
        san: 'SAN',
        ceph: 'Ceph',
        other: 'Muut',
        legacy: 'Legacy'
      },
      legacyHint: 'Täysin tuettuja — emme vain valitsisi niitä uuteen asennukseen.',
      proto: {
        dir: {
          name: 'Paikallinen kansio',
          desc: 'Solmun hakemisto: yksinkertainen ja nopea. Se on PAIKALLINEN yhdelle solmulle, ellei polku ole aidosti jaettu share — sen merkitseminen jaetuksi, kun se ei ole, maksaa dataa.',
          usage: 'TVirt säilyttää siellä VM:ien levyjä, ISO- ja levykuvia sekä templateja.'
        },
        nfs: {
          name: 'NFS',
          desc: 'Klusterin mounttaama NFS-export — luonnostaan jaettu.',
          usage: 'Isännöi VM:ien levyjä, ISO- ja levykuvia sekä templateja.'
        },
        cifs: {
          name: 'CIFS/SMB',
          desc: 'Klusterin mounttaama Windows/Samba-share — luonnostaan jaettu.',
          usage: 'Isännöi VM:ien levyjä, ISO- ja levykuvia sekä templateja.'
        },
        sftp: {
          name: 'SFTP',
          desc: 'Etätiedostojärjestelmä SSH:n yli — ilman NAS-exportin tarvetta.',
          usage: 'Roadmapilla.'
        },
        iscsi: {
          name: 'iSCSI',
          desc: 'Lohkotason LUNit IP:n yli, päällä jaettu LVM.',
          usage: 'Vain levyjä — yksi thin-volyymi levyä kohden; ei isännöi ISO-levykuvia eikä templateja.'
        },
        rbd: {
          name: 'Ceph RBD',
          desc: 'Ceph-klusteriin hajautetut block devicet.',
          usage: 'Vain levyjä — yksi RBD-levykuva levyä kohden, QEMU avaa sen natiivisti; ei isännöi ISO-levykuvia.'
        },
        cephfs: {
          name: 'CephFS',
          desc: 'Cephin hajautettu tiedostojärjestelmä, kernelin mounttaama klusterilla — shared by nature.',
          usage: 'Isännöi VM-levyjä, ISO- ja levykuvia sekä templateja — dir-perhe Ceph-tiedostojärjestelmän päällä (cephx-tunnistetieto pakollinen).'
        },
        fc: { name: 'SCSI/FC', desc: 'SCSI-LUNit FibreChannel-fabricissa — klassinen FC-SAN.' },
        fcoe: { name: 'SCSI/FCoE', desc: 'Sama SCSI FibreChannelin yli, FC-framet kapseloituina Ethernetiin.' },
        'iscsi-lun': {
          name: 'iSCSI (kokonaiset LUNit)',
          desc: 'iSCSI-kohde kokonaisten LUNien kantajana: jokainen levy ON LUN, joka annetaan vieraalle raakana — ilman LVM:ää välissä.',
          usage: 'Vain levyt — yksi koko LUN per levy, otettu käyttöön sellaisenaan; jaetun kirjoituksen levyjen SAN-koti.'
        },
        'nvme-tcp-lun': {
          name: 'NVMe/TCP (kokonaiset nimiavaruudet)',
          desc: 'NVMe-alijärjestelmä kokonaisten nimiavaruuksien kantajana: jokainen levy ON nimiavaruus, joka annetaan vieraalle raakana.',
          usage: 'Vain levyt — yksi koko nimiavaruus per levy, otettu käyttöön sellaisenaan; jaettu kirjoitus kyllä, SCSI persistent reservations ei.'
        },
        'nvme-tcp': {
          name: 'NVMe/TCP',
          desc: 'Etä-NVMe — ei SCSI:tä polulla — pelkän TCP:n yli, päällä jaettu LVM.',
          usage: 'Vain levyjä — yksi thin-volyymi levyä kohden; ei isännöi ISO-levykuvia eikä templateja.'
        },
        nvmefc: { name: 'NVMe/FC', desc: 'Etä-NVMe FibreChannel-fabricissa.' },
        nvmefcoe: { name: 'NVMe/FCoE', desc: 'NVMe FibreChannel-fabricissa, jonka FCoE kuljettaa Ethernetin sisällä — FCoE- ja NVMe/FC-layerit pinottuina.' },
        iser: { name: 'iSCSI/RDMA (iSER)', desc: 'iSCSI, jonka datapolku on siirretty RDMA:lle — mikä tahansa fabric (InfiniBand, iWARP, RoCE). NVMe/RDMA:n ohittama, yhä läsnä arrayissa ja ESXissä.' },
        srp: { name: 'SCSI/RDMA (SRP)', desc: 'Natiivi SCSI RDMA:n yli, pre-iSER-aikakausi: InfiniBand (fabric-discoveryllä) ja RoCE — elää yhä ikääntyneissä HPC-storageissa.' },
        nvmerdma: { name: 'NVMe/RDMA', desc: 'Etä-NVMe minkä tahansa RDMA-fabricin yli — InfiniBand, iWARP, RoCE v1 ja v2: yksi ainoa konfiguraatio, solmu kertoo, mikä sillä on.' },
        s3: { name: 'S3', desc: 'S3-yhteensopiva object storage — levykuvat ja backupit.' }
      }
    },
    catalogs: {
      title: 'Katalogit',
      createTitle: 'Luo katalogi',
      editTitle: 'Muokkaa katalogia',
      docTitle: 'Katalogi',
      notFound: 'Tätä katalogia ei ole (enää?) olemassa',
      scopeHint: 'Joka lukee tämän scopen, näkee (ja voi käyttää) katalogin jokaisen tiedoston',
      files: 'Tiedostot',
      noFiles: 'Ei tiedostoja',
      count: {
        iso: 'ISO',
        ctRootfs: 'CT-tpl',
        vmTemplate: 'VM-tpl',
        ociImage: 'OCI',
        firmwareOvmf: 'Firmware'
      },
      systemChip: 'järjestelmä',
      systemTooltip: 'Järjestelmäkatalogi: isännöi alustan sisäänrakennetut objektit eikä sitä voi muokata'
    },
    catalogFiles: {
      catalog: 'Katalogi',
      kindLabel: 'Tyyppi',
      physicalSize: 'Fyysinen koko',
      virtualSize: 'Virtuaalinen koko',
      importTemplateAction: 'Tuo VM Templatena',
      importTemplateLegacy: 'Ei ilmoitettua formaattia — käytettävissä levyjen seedinä, ei tuotavissa',
      importTemplateTitle: 'Tuo VM Templatena',
      importTemplateSubmit: 'Tuo',
      importTemplateError: 'Import epäonnistui',
      importTemplateHint: 'Paketista .tvtpl tulee VM Template: manifestin jäädytetty laitteisto sekä yksi levy arkiston jokaista entryä kohden, jokainen todennettu omaa checksumiaan vasten. NICit ja CD/DVD-mediat eivät kuulu arkistoon — lisää ne importin jälkeen.',
      importTemplateQcow2Hint: 'Paljaasta qcow2:sta tulee YHDEN levyn template ilmoitetulla oletuslaitteistolla: linux-profiili, UEFI, 2 vCPU, 2048 MiB, boot sen ainoalta levyltä. Korjaa deployn yhteydessä.',
      importTemplateName: 'Templaten nimi',
      importTemplateNameHint: 'Tyhjä = {name} (-import-<n>, jos varattu)',
      importTemplateStorage: 'Storage levyille',
      importTemplateMetadataStorage: 'Metadata-storage',
      importTemplateMetadataHint: 'Lohkotason storage ei isännöi VM-metadataa (firmware, varstore) — valitse dir/nfs/cifs-storage.',
      importTemplateStarted: 'Import käynnistetty — template ilmestyy Template-välilehdelle taskin päättyessä.',
      kind: {
        iso: 'ISO-levykuva',
        'ct-rootfs': 'CT-rootfs',
        'vm-template': 'VM-template',
        'oci-image': 'OCI-image',
        'firmware-ovmf': 'OVMF-firmware'
      },
      title: {
        iso: 'ISO-levykuvat',
        'ct-rootfs': 'CT-templatet',
        'vm-template': 'VM-templatet',
        'oci-image': 'OCI-imaget',
        'firmware-ovmf': 'OVMF-firmwaret'
      },
      createTitle: {
        iso: 'Lisää ISO-levykuva',
        'ct-rootfs': 'Rekisteröi CT-template',
        'vm-template': 'Lisää VM-template',
        'oci-image': 'Lisää OCI-image',
        'firmware-ovmf': 'Lisää OVMF-firmware'
      },
      formatHint: 'Johdettu valitun tiedoston päätteestä — korjaa, jos arvaus meni pieleen',
      tarballHint: 'Rootfs-tarball LXC-standardiformaatissa (.tar.gz / .tar.xz / .tar.zst / .tar.bz2 tai pelkkä .tar)',
      ociArchiveHint: 'docker-archive-/oci-archive-tarball (.tar tai .tar.gz), esimerkiksi docker save -komennosta',
      uploadResumeHint: 'Upload keskeytyi — tiedosto odottaa uploadia: lähetä uudelleen samalla tiedostolla jatkaaksesi',
      moveTitle: 'Siirrä tiedosto',
      moveHint: 'Kaksi riippumatonta ulottuvuutta: Katalogi siirtää linkin (sama id, yhtään tavua ei siirry, scope muuttuu kohdekatalogin scopeksi); Storage siirtää datan — jokainen linkitetty kopio seuraa mukana, hylätään kun tiedosto on käytössä. Yhdessä valittuina ensin katalogi, sitten storage.',
      moveCatalog: 'Kohdekatalogi',
      moveCatalogHint: 'Vain linkki vaihtaa kotia: tiedoston liittäneen VM:n on nähtävä kohdekatalogi',
      keepCurrent: 'Älä muuta',
      rehomed: 'Linkki siirretty valittuun katalogiin',
      copyAction: 'Kopioi katalogiin…',
      copyTitle: 'Kopioi katalogiin',
      copyLinkHint: 'Kopio on uusi linkki samaan dataan — mitään ei duplikoida storagella.',
      copyCatalog: 'Kohdekatalogi',
      copyCatalogHint: 'Kopiointi on tapa, jolla tiedosto matkaa katalogien välillä',
      sameCatalog: 'Sama kuin lähteellä',
      sharedObjectHint: 'Tämän tiedoston datan jakaa {count} linkitettyä kopiota',
      deleteLastLink: 'Tämä on VIIMEINEN linkki tähän sisältöön: myös data poistetaan storagelta.',
      deleteLinkOnly: 'Vain tämä linkki poistetaan — data säilyy ja on yhä muiden linkitettyjen kopioiden ({count}) tavoitettavissa.',
      noCatalog: 'Ei yhtään katalogia — luo sellainen',
      inlineCatalogName: 'Katalogin nimi',
      embeddedChip: 'sisäänrakennettu',
      embeddedStorage: 'Sisäänrakennettu alustaan',
      embeddedNoMove: 'Alustan sisäänrakennettu tiedosto: ei elä millään storagella — kloonaa se sen sijaan',
      embeddedCopyHint: 'Klooni materialisoi sisäänrakennetut tavut oikealle storagelle: valitse kohdestorage ja -katalogi — kopio on tavallinen tiedosto',
      sourceEmbedded: 'Sisäänrakennettu alustaan',
      nodesRow: 'Läsnäolo solmuittain',
      nodesSummary: '{present} / {total} solmua sisältää sen',
      nodePresent: 'löytyy',
      nodeMissing: 'puuttuu',
      nodeUnknown: 'ei vielä raportoitu',
      nodesHint: 'Resurssi sijaitsee jokaisen solmun levyllä (paketti trantor-tvirt-assets): solmu, jolta se puuttuu, ei voi määritellä tällä laiteohjelmistolla varustettua VM:ää eikä tarjota Guest Toolsia. Eri versiot solmujen välillä ovat normaaleja vaiheittaisen päivityksen aikana.',
      downloadAction: 'Lataa',
      downloadNotReady: 'Sisältö ei ole vielä valmis — download vaatii ready-tilassa olevan tiedoston',
      downloadDenied: 'Roolisi ei sisällä oikeutta catalog.download — tavujen lataaminen on tiedoston käytöstä erillinen oikeus',
      objectRow: 'Storage-objekti',
      objectLinksRow: 'Linkitetyt kopiot',
      declaredChecksum: 'Ilmoitettu SHA-256',
      usedByRow: 'Käytössä',
      usedByVms: 'VM:t',
      usedByDisks: 'Levyt',
      transferRow: 'Siirto',
      storageLockHint: 'Muuttuu vain Siirrä-toiminnolla'
    },
    objects: {
      action: 'Selaa sisältöä',
      title: 'Storagen sisältö',
      hint: 'Vain luku -inventointi siitä, mitä tällä storagella elää — jokaista objektia hallitaan omasta osiostaan.',
      empty: 'Ei rekisteröityjä objekteja tällä storagella',
      loadError: 'Sisältöä ei voitu ladata',
      colDetail: 'Tiedot',
      manage: 'Hallitse omassa osiossaan',
      kind: {
        disk: 'Levy',
        catalogFile: 'Katalogitiedosto',
        ociBlob: 'OCI-blob',
        checkpoint: 'Checkpoint',
        vmMetadata: 'VM-metadata',
        appRoot: 'App-root',
        appVolume: 'App-volyymi'
      }
    },
    inventory: {
      tabCatalogs: 'Katalogit',
      storage: 'Storage',
      sizeGib: 'Koko (GiB)',
      format: 'Formaatti',
      size: 'Koko',
      sourceType: 'Lähde',
      sourceFile: 'Tiedoston lähetys',
      sourceUrl: 'Download URL:sta',
      file: 'Tiedosto',
      url: 'URL',
      checksum: 'SHA-256-checksum',
      checksumHint: 'Pakollinen: download todennetaan tätä SHA-256:ta vasten',
      verifyChecksum: 'Tarkista checksum',
      checksumOffHint: 'Download hyväksytään ilman todennusta — laskettu SHA-256 rekisteröidään silti',
      uploading: 'Lähetetään…',
      move: {
        action: 'Siirrä',
        diskTitle: 'Siirrä levy',
        target: 'Kohdestorage',
        diskHint: 'Levy säilyttää identiteettinsä: tavut matkaavat valitulle storagelle. Sitä käyttävän VM:n on oltava sammutettu; jos snapshoteja on, iSCSI-osapuoli hylkää siirron.',
        noTargets: 'Ei yhteensopivaa kohdestoragea',
        submit: 'Siirrä',
        error: 'Siirto hylättiin'
      },
      clone: {
        action: 'Kloonaa',
        title: 'Kloonaa levy',
        name: 'Kopion nimi',
        storage: 'Kohdestorage',
        sameStorage: 'Sama kuin lähteellä',
        linked: 'Linked clone',
        linkedHint: 'Välitön qcow2-overlay ketjutettuna lähdelevyyn (vain qcow2-lähteet). Oletus on täysi kopio.',
        linkedCrossHint: 'Linked clone pysyy lähteen storagella: valitse "Sama kuin lähteellä" ottaaksesi sen käyttöön.',
        submit: 'Kloonaa',
        error: 'Kloonaus hylättiin'
      },
      copy: {
        action: 'Kopioi',
        name: 'Kopion nimi',
        storage: 'Kohdestorage',
        sameStorage: 'Sama kuin lähteellä',
        submit: 'Kopioi',
        error: 'Kopiointi hylättiin'
      },
      taskStarted: 'Käynnistetty — jatkuu taskina taustalla',
      cephObjects: 'Siirry objektin tietoihin Cephissä',
      phase: {
        ready: 'Valmis',
        creating: 'Luodaan',
        'awaiting-upload': 'Odottaa uploadia',
        downloading: 'Ladataan',
        verifying: 'Todennetaan',
        deleting: 'Poistetaan',
        error: 'Virhe',
        'in-use': 'Käytössä'
      }
    }
  }
}
